import LogtoClient, { type LogtoConfig } from "@logto/browser";

/**
 * Logto rotates refresh tokens on every use for public SPA clients.
 * The SDK only memoizes `getAccessToken` per resource argument, so parallel
 * refreshes for `api.gowoop.de` and `backend.gowoop.de` can reuse the same
 * refresh token and get `invalid_grant` ("Grant request is invalid").
 *
 * Serialize all access-token fetches so only one refresh grant runs at a time.
 */
export class SerializedRefreshLogtoClient extends LogtoClient {
  constructor(config: LogtoConfig, unstable_enableCache = false) {
    super(config, unstable_enableCache);

    const originalGetAccessToken = this.getAccessToken.bind(this);
    let refreshChain: Promise<unknown> = Promise.resolve();

    Object.defineProperty(this, "getAccessToken", {
      configurable: true,
      value: (resource?: string, organizationId?: string) => {
        const run = refreshChain.then(() =>
          originalGetAccessToken(resource, organizationId),
        );
        // Keep the queue moving even when a refresh fails.
        refreshChain = run.then(
          () => undefined,
          () => undefined,
        );
        return run;
      },
    });
  }
}
